import type { CancelReasonCode } from '../../../pages/settings/sections/billing/cancel-reasons'
import { api } from '../client'

export interface SubscriptionResponse {
  status: 'trialing' | 'active' | 'past_due' | 'canceled' | 'incomplete'
  seats: { admin: number; publisher: number; viewer: number }
  billingCadence: 'monthly' | 'annual'
  currentPeriodEnd: string | null
  trialEnd: string | null
  cancelAtPeriodEnd: boolean
}
export interface BalanceResponse {
  availableCredits: number
  reservedCredits: number
}
export interface UpdateSeatsInput {
  admin?: number
  publisher?: number
  viewer?: number
}
export type TopupResponse = { status: 'charged'; chargeRef: string } | { checkoutUrl: string; chargeRef: string }
export interface TopupInput {
  blockCount: number
  /**
   * One id per submit INTENT — REQUIRED, not optional. It is what tells the server
   * "this request and the earlier one carrying the same id are the same purchase",
   * so a retry after a timeout replays the first charge instead of billing the card
   * twice. Omitting it falls back to a server-side `blockCount + 60s bucket` GUESS,
   * which cannot distinguish a double-submit from a deliberate second purchase and
   * therefore refuses (409) rather than answering. Hold one id across retries of the
   * SAME submit; mint a fresh one for a new purchase.
   */
  idempotencyKey: string
}

export const billingApi = {
  getSubscription: () => api.get<SubscriptionResponse>('/billing/subscription'),
  getBalance: () => api.get<BalanceResponse>('/billing/balance'),
  updateSeats: (input: UpdateSeatsInput) => api.post<{ seats: SubscriptionResponse['seats'] }>('/billing/seats', input),
  topup: (input: TopupInput) => api.post<TopupResponse>('/billing/topup', input),
  portal: () => api.get<{ url: string }>('/billing/portal'),
  cancelSubscription: (input: { reasonCode?: CancelReasonCode; note?: string }) =>
    api.post<SubscriptionResponse>('/billing/cancel', input),
  reactivateSubscription: () => api.post<SubscriptionResponse>('/billing/reactivate', {}),
}
